var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2, _path1, _path10, _circle, _circle2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDocumentSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 148,
    viewBox: "0 0 149 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5011 74.1873C23.5011 45.8502 46.5741 23 74.907 23C103.24 23 126.313 45.8333 126.313 74.1873C126.313 86.2159 122.144 97.2774 115.164 106.012C105.532 118.108 90.8289 125.376 74.9059 125.376C58.983 125.376 44.2604 118.063 34.6406 106.012C27.6604 97.2785 23.5 86.2169 23.5 74.1873H23.5011Z",
    fill: "url(#paint0_linear_17919_31767)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.84 77.0537C134.724 76.0286 134.593 74.4709 133.563 73.5906C132.534 72.7102 130.982 72.8275 130.098 73.8526C129.214 74.8777 129.32 76.4365 130.35 77.3179C131.379 78.1982 132.957 78.0788 133.841 77.0537H133.84Z",
    fill: "url(#paint1_linear_17919_31767)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.262 69.5801C134.825 68.927 134.741 67.9368 134.086 67.3756C133.43 66.8155 132.443 66.8905 131.881 67.5426C131.318 68.1957 131.385 69.187 132.041 69.7481C132.697 70.3082 133.701 70.2321 134.263 69.5801H134.262Z",
    fill: "url(#paint2_linear_17919_31767)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2623 26.5801C45.8248 25.927 45.741 24.9368 45.0861 24.3756C44.4303 23.8155 43.4432 23.8905 42.8807 24.5426C42.3182 25.1957 42.3851 26.187 43.041 26.7481C43.6969 27.3082 44.7009 27.2321 45.2634 26.5801H45.2623Z",
    fill: "url(#paint3_linear_17919_31767)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5008 122.205C40.8574 121.422 40.4976 120.494 39.7112 120.139C38.9247 119.784 37.9972 120.132 37.6406 120.916C37.284 121.699 37.6289 122.633 38.4153 122.988C39.2018 123.343 40.1442 122.989 40.5008 122.206V122.205Z",
    fill: "url(#paint4_linear_17919_31767)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2157 126.465C48.776 125.234 48.2104 123.777 46.9739 123.219C45.7375 122.661 44.2814 123.207 43.721 124.438C43.1606 125.669 43.7019 127.136 44.9383 127.693C46.1748 128.251 47.6553 127.695 48.2157 126.464V126.465Z",
    fill: "url(#paint5_linear_17919_31767)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8403 31.0537C41.7244 30.0286 41.5928 28.4709 40.5633 27.5906C39.5338 26.7102 37.9822 26.8275 37.0981 27.8526C36.214 28.8777 36.3201 30.4365 37.3496 31.3179C38.3791 32.1982 39.9573 32.0788 40.8413 31.0537H40.8403Z",
    fill: "url(#paint6_linear_17919_31767)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6119 30.0514L89.6124 30.0518L107.136 46.1302L107.136 46.1303C108.137 47.0479 108.825 48.2436 109.117 49.5423L109.118 49.5475C109.236 50.0314 109.291 50.523 109.291 51.0318V51.3318H109.292V114.045C109.292 117.724 106.317 120.699 102.639 120.699H45.4532C41.7751 120.699 38.8 117.724 38.8 114.045V34.9534C38.8 31.2752 41.7751 28.3 45.4532 28.3H85.1228C85.4693 28.3 85.8104 28.3275 86.1454 28.3763C87.4306 28.5777 88.6397 29.1553 89.6119 30.0514Z",
    fill: "white",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.023 49.1779H89.5552C87.8623 49.1779 86.4895 47.805 86.4895 46.1121V28.4411C87.6454 28.6855 88.7262 29.2372 89.6111 30.0527L89.6115 30.0532L107.135 46.1316L107.135 46.1317C108.042 46.9625 108.691 48.0212 109.023 49.1779Z",
    fill: "url(#paint7_linear_17919_31767)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111C46 109.895 46.8954 109 48 109H94C95.1046 109 96 109.895 96 111V113C96 114.105 95.1046 115 94 115H48C46.8954 115 46 114.105 46 113V111Z",
    fill: "#C3CEF5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 35,
    width: 33,
    height: 6,
    rx: 2,
    fill: "#C3CEF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 45,
    width: 18,
    height: 6,
    rx: 2,
    fill: "#C3CEF5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M113.375 102.965L108.464 107.855L102.781 102.204C104.672 100.783 106.373 99.0653 107.701 97.3145L113.376 102.965H113.375Z",
    fill: "url(#paint8_linear_17919_31767)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.056 102.136L128.048 113.081C130.651 115.673 130.651 119.878 128.048 122.47C125.444 125.062 121.222 125.062 118.618 122.47L107.627 111.525C106.843 110.745 106.843 109.479 107.627 108.698L114.217 102.136C115.001 101.356 116.273 101.356 117.056 102.136Z",
    fill: "url(#paint9_linear_17919_31767)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.3213,
    cy: 81.8213,
    r: 25.5213,
    fill: "url(#paint10_linear_17919_31767)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6675,
    cy: 82.1675,
    r: 18.5914,
    fill: "url(#paint11_linear_17919_31767)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5666 83.368C84.5666 85.0188 83.2315 86.3538 81.5804 86.3538C79.9293 86.3538 78.5996 85.0188 78.5996 83.368C78.5996 81.7172 79.9348 80.3877 81.5804 80.3877C83.226 80.3877 84.5666 81.7226 84.5666 83.368Z",
    fill: "#5A7FFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3837 83.9774C83.3837 84.6284 82.8562 85.1558 82.2051 85.1558C81.554 85.1558 81.0293 84.6284 81.0293 83.9774C81.0293 83.3264 81.5567 82.8018 82.2051 82.8018C82.8534 82.8018 83.3837 83.3291 83.3837 83.9774Z",
    fill: "#F9FAFD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0119 83.367C99.0119 85.0179 97.6767 86.3528 96.0257 86.3528C94.3746 86.3528 93.0449 85.0179 93.0449 83.367C93.0449 81.7162 94.3801 80.3867 96.0257 80.3867C97.6712 80.3867 99.0119 81.7217 99.0119 83.367Z",
    fill: "#5A7FFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8251 83.9774C97.8251 84.6284 97.2976 85.1558 96.6465 85.1558C95.9954 85.1558 95.4707 84.6284 95.4707 83.9774C95.4707 83.3264 95.9982 82.8018 96.6465 82.8018C97.2949 82.8018 97.8251 83.3291 97.8251 83.9774Z",
    fill: "#F9FAFD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5288 78.489L95.125 76.8409C94.6168 76.6514 94.3613 76.0855 94.5508 75.5801C94.7404 75.072 95.3063 74.8138 95.8118 75.006L100.216 76.6541C100.724 76.8437 100.979 77.4095 100.79 77.9177C100.597 78.4313 100.029 78.6813 99.5288 78.4918V78.489Z",
    fill: "#5A7FFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2481 77.9153C77.0585 77.4071 77.314 76.844 77.8223 76.6517L82.2261 75.0036C82.7343 74.8141 83.2975 75.0723 83.4898 75.5777C83.6794 76.0859 83.4239 76.649 82.9156 76.8385L78.5118 78.4866C78.0118 78.6734 77.4404 78.4262 77.2509 77.9125L77.2481 77.9153Z",
    fill: "#5A7FFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3748 89.5037C91.3748 90.4623 90.3198 90.6601 89.0204 90.6601C87.721 90.6601 86.666 90.4623 86.666 89.5037C86.666 88.5451 87.721 87.5645 89.0204 87.5645C90.3198 87.5645 91.3748 88.5505 91.3748 89.5037Z",
    fill: "#5A7FFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17919_31767",
    x1: 31,
    y1: 28.5,
    x2: 91.5,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17919_31767",
    x1: 131.964,
    y1: 73,
    x2: 131.964,
    y2: 77.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17919_31767",
    x1: 133.068,
    y1: 67,
    x2: 133.068,
    y2: 70.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17919_31767",
    x1: 44.068,
    y1: 24,
    x2: 44.068,
    y2: 27.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17919_31767",
    x1: 39.0694,
    y1: 120,
    x2: 39.0694,
    y2: 123.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17919_31767",
    x1: 45.9662,
    y1: 123,
    x2: 45.9662,
    y2: 127.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17919_31767",
    x1: 38.9638,
    y1: 27,
    x2: 38.9638,
    y2: 31.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17919_31767",
    x1: 86.1895,
    y1: 38.7795,
    x2: 109.409,
    y2: 38.7795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17919_31767",
    x1: 102.781,
    y1: 102.585,
    x2: 113.375,
    y2: 102.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17919_31767",
    x1: 112.594,
    y1: 104.545,
    x2: 128.086,
    y2: 121.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95A8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17919_31767",
    x1: 69.73,
    y1: 62.1971,
    x2: 108.462,
    y2: 103.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6B9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_17919_31767",
    x1: 75.7569,
    y1: 68.224,
    x2: 100.029,
    y2: 97.1439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocumentSad);
export default __webpack_public_path__ + "static/media/no-document-sad.5b7ee01ba21cf4dc37668cc0d9afb68e.svg";
export { ForwardRef as ReactComponent };